import { useContext, useRef, useState } from 'react';
import { LOCAL_STORAGE_TOKEN } from "lib/axios";
import { AuthContext } from "contexts/AuthContext";

export const useWebSocket = (setOrderedData, setAnswer, setLoading, setShowHumanFeedback, setQuestionForHuman) => {
    const { state } = useContext(AuthContext);
    const [socket, setSocket] = useState(null);
    const heartbeatInterval = useRef();

    const initializeWebSocket = (promptValue, chatBoxSettings) => {
        const openai_keys = state.profile?.domain?.settings?.openai_keys || {};
        const OPENAI_API_KEY = Object.values(openai_keys)?.length ? Object.values(openai_keys)[0] : '';
        const headers = { 'retriever': chatBoxSettings['report_retriever'], ...(OPENAI_API_KEY ? { OPENAI_API_KEY } : {}) };

        if (!socket && typeof window !== 'undefined') {
            const { protocol, pathname } = window.location;
            const token = localStorage.getItem(LOCAL_STORAGE_TOKEN) || '';
            let { host } = window.location;
            host = host.includes('localhost') ? 'localhost:8003' : (host + '/api');
            const ws_uri = `${protocol === 'https:' ? 'wss:' : 'ws:'}//${host}${pathname}ws?t=${token}`;

            console.log('ws_uri -> useWebSocket', ws_uri)

            const newSocket = new WebSocket(ws_uri);
            setSocket(newSocket);

            newSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.type === 'human_feedback' && data.content === 'request') {
                    setQuestionForHuman(data.output);
                    setShowHumanFeedback(true);
                } else {
                    const contentAndType = `${data.content}-${data.type}`;
                    setOrderedData((prevOrder) => [...prevOrder, { ...data, contentAndType }]);

                    if (data.type === 'report') {
                        setAnswer((prev) => prev + data.output);
                    } else if (data.type === 'path' || data.type === 'chat') {
                        setLoading(false);
                    }
                }
            };

            const { report_retriever, report_type, report_source, tone } = chatBoxSettings;
            let data = "start " + JSON.stringify({ task: promptValue, report_type, report_source, tone, headers });
            console.log('data', data)

            newSocket.onopen = () => {
                const { report_retriever, report_type, report_source, tone } = chatBoxSettings;
                let data = "start " + JSON.stringify({ task: promptValue, report_type, report_source, tone, headers });
                console.log('data onopen', data)
                newSocket.send(data);

                heartbeatInterval.current = window.setInterval(() => {
                    socket?.send('ping');
                }, 3000); // Send ping every 3 seconds
            };

            newSocket.onclose = () => {
                if (heartbeatInterval.current) {
                    clearInterval(heartbeatInterval.current);
                }
                setSocket(null);
            };
        } else if (socket) {
            const { report_retriever, report_type, report_source, tone } = chatBoxSettings;
            let data = "start " + JSON.stringify({ task: promptValue, report_type, report_source, tone, headers });
            socket.send(data);
        }
    };

    return { socket, setSocket, initializeWebSocket };
};
